module.exports = __webpack_public_path__ + "img/locations.c722dab0.png";